// extracted by mini-css-extract-plugin
export default {"flagContainer":"language_flagContainer__wEEzR"};